import {PAYEE_CATALOG_TYPE_DELIVERY_API_RESPONSE_CODES} from "../../constants/payeeCatalog"
import { getNextOpeningStatusMessage } from "../../utils/payeeUtils"
import { useSelector } from "react-redux"
import { capitalizeAllWords } from "../../utils/stringUtils"

/**
 * Purpose: communicate exactly why delivery is unavailable
 */
const DeliveryUnavailableBadge = ({
    deliveryAvailability,
    countryId=""
}) => {
    const {
        toSettlementId="",
        fromSettlementId="",
        available: deliveryAvailable=false,
        code: errorCode="",
        openingTimes: deliveryOpeningTimes={}
    } = deliveryAvailability || {}
    const country = useSelector(state => state.countries.countriesById[countryId] || null)
    const {settlements:settlementNamesById={}} = country || {}
    const deliverySettlementName = settlementNamesById[toSettlementId] || ""
    const pickupSettlementName = settlementNamesById[fromSettlementId] || ""

    //if delivery is available return nothing. This is for unavailable delivery
    if (deliveryAvailable && typeof deliveryAvailable === "boolean") return null
    let errorMessage = "Delivery unavailable"
    let infoMessage = ""
    switch (errorCode) {
        case PAYEE_CATALOG_TYPE_DELIVERY_API_RESPONSE_CODES.OUT_OF_DELIVERY_RANGE: {
            errorMessage =`Cannot deliver ${deliverySettlementName ? ` to ${capitalizeAllWords(deliverySettlementName)}` : ""}`;
            infoMessage = `Try an area nearer to ${capitalizeAllWords(pickupSettlementName)}`
            break;
        }
        case PAYEE_CATALOG_TYPE_DELIVERY_API_RESPONSE_CODES.OUT_OF_PICKUP_RANGE: {
            errorMessage =`Cannot pick up ${deliverySettlementName ? ` from ${capitalizeAllWords(pickupSettlementName)}` : ""}`;
            break;
        }
        case PAYEE_CATALOG_TYPE_DELIVERY_API_RESPONSE_CODES.CLOSED: {
            errorMessage =`Delivery service is closed`;
            const {isOpen, nextOpeningTime, nextClosingTime} = deliveryOpeningTimes || {}
            infoMessage = getNextOpeningStatusMessage(isOpen, nextOpeningTime, nextClosingTime)
            break;
        }
        case PAYEE_CATALOG_TYPE_DELIVERY_API_RESPONSE_CODES.INACTIVE: {
            errorMessage =`Delivery service is not active`;
            break;
        }
        default: errorMessage = "Delivery unavailable"
    }
    return <div className="display-flex margin-top-5px">
                <div className="badge error">{errorMessage}</div>
                {infoMessage ? <div className="font-size-14px margin-left-05em">{infoMessage}</div> : null}
            </div>
    
}

export default DeliveryUnavailableBadge